/**
 * Único ponto de leitura das env vars do Vite (`import.meta.env`).
 *
 * Isolado aqui porque `import.meta` não é sintaxe válida para o Jest (roda em
 * CommonJS, não ESM) — qualquer arquivo que use `import.meta.env` diretamente
 * quebra a suíte inteira com "Cannot use 'import.meta' outside a module". Em
 * teste, este módulo é substituído por `env.jest.ts` via `moduleNameMapper`
 * (`jest.config.cjs`), então o `import.meta` real nunca chega a ser parseado.
 */
export const env = {
  DEV: import.meta.env.DEV,
  VITE_API_URL: import.meta.env.VITE_API_URL as string | undefined,
  VITE_API_TIMEOUT: import.meta.env.VITE_API_TIMEOUT as string | undefined,
  /** Endereço do ImpostoCerto (Módulo de Recebimento), para o atalho da SPEC-018. */
  VITE_IMPOSTOCERTO_APP_URL: import.meta.env.VITE_IMPOSTOCERTO_APP_URL as string | undefined,
};
